export default "__VITE_ASSET__55b4d787__"